import { render, staticRenderFns } from "./commentBox.vue?vue&type=template&id=c147c59e&scoped=true&"
import script from "./commentBox.vue?vue&type=script&lang=js&"
export * from "./commentBox.vue?vue&type=script&lang=js&"
import style0 from "./commentBox.vue?vue&type=style&index=0&id=c147c59e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c147c59e",
  null
  
)

export default component.exports